import React, { useContext, useState } from 'react'
import { Routes, Route, useNavigate, useLocation } from 'react-router'
import { auth } from '../../firebase'
import { UserContext } from '../../contexts/userContext'
import { CustomLayout } from './style'
import { Layout, Menu, Button } from 'antd'
import { MenuFoldOutlined, MenuUnfoldOutlined, HomeOutlined, LineChartOutlined, SendOutlined, RobotOutlined, UsergroupAddOutlined, DollarCircleOutlined, StopOutlined, CreditCardOutlined, ExportOutlined, FrownOutlined, MessageOutlined } from '@ant-design/icons'
import btm_logo from '../../assets/btm_logo.png'
import TableHistory from '../../components/tableHistory'
import TableLeadConvesions from '../../components/tableLeadConversions'
import LeadsIn from '../../components/leadsIn'
import LeadsRejected from '../../components/leadsRejected'
import LeadsBlocked from '../../components/leadsBlocked'
import LeadsShared from '../../components/leadsShared'
import TestZone from '../../components/testZone'
import Home from '../../components/home/home'
import ListGrowth from '../../components/listGrowth'
import OptiFeebackBounces from '../../components/optiFeebackBounces'
import OptiFeedbackComplaints from '../../components/optiFeedbackComplaints'
import NotFound from '../../components/errors/404'
import Sms from '../../components/sms'

const { Header, Content, Sider } = Layout

const Dashboard = () => {

  const { user } = useContext(UserContext)

  const [collapsed, setCollapsed] = useState(false)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const handleSignOut = async () => {

    setLoading(true)

    try {

      await auth.signOut()

    } catch (err) {

      console.error('Error Sign Out', err)

    } finally {

      setLoading(false)
    }
  }

  const routes = [
    {
      key: '/',
      label: 'HOME',
      icon: <HomeOutlined />,
      page: <Home />
    }, {
      key: '/checkout_pages',
      label: 'CHECKOUT PAGES',
      icon: <CreditCardOutlined />,
      page: <TableHistory />
    }, {
      key: '/leads_shared',
      label: 'LEADS SHARED',
      icon: <SendOutlined />,
      page: <LeadsShared />,
    }, {
      key: '/leads_in',
      label: 'LEADS IN',
      icon: <UsergroupAddOutlined />,
      page: <LeadsIn />
    }, {
      key: '/leads_rejected',
      label: 'LEADS REJECTED',
      icon: <RobotOutlined />,
      page: <LeadsRejected />
    }, {
      key: '/leads_converted',
      label: 'LEADS CONVERTED',
      icon: <DollarCircleOutlined />,
      page: <TableLeadConvesions />
    }, {
      key: '/leads_blocked',
      label: 'LEADS BLOCKED',
      icon: <StopOutlined />,
      page: <LeadsBlocked />
    }, {
      key: '/mw_bounces',
      label: 'MW BOUNCES',
      icon: <ExportOutlined />,
      page: <OptiFeebackBounces />
    }, {
      key: '/mw_complaints',
      label: 'MW COMPLAINTS',
      icon: <FrownOutlined />,
      page: <OptiFeedbackComplaints />
    }, {
      key: '/list_growth',
      label: 'LIST GROWTH',
      icon: <LineChartOutlined />,
      page: <ListGrowth />
    }, {
      key: '/sms',
      label: 'SMS',
      icon: <MessageOutlined />,
      page: <Sms />
    }
  ]

  if (process.env.REACT_APP_TEST_USERS?.includes(user.email)) {
    routes.push({
      key: '/test',
      label: <b>TEST ZONE</b>,
      page: <TestZone />
    })
  }

  return (
    <CustomLayout>
      <Sider
        breakpoint='lg'
        collapsedWidth='0'
        collapsed={collapsed}
        collapsible
        onBreakpoint={broken => setCollapsed(broken)}
        trigger={null}
        theme='light'
      >
        <article className='logo'>
          <img src={btm_logo} alt='btm logo' />
        </article>
        <Menu
          theme='light'
          mode='inline'
          defaultSelectedKeys={routes[0].key}
          defaultOpenKeys={routes[0].key}
          selectedKeys={[location.pathname]}
          onSelect={(item) => navigate(item.key)}
          items={routes}
        />
      </Sider>
      <CustomLayout>
        <Header className='site-layout-sub-header-background'>
          {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
            className: 'trigger',
            onClick: () => setCollapsed(!collapsed),
          })}
          <article className='email-wrap'>{user.email}</article>
          <Button type="primary" ghost onClick={handleSignOut} loading={loading}>
            Sign Out
          </Button>
        </Header>
        <Content>
          <article className='site-layout-background'>
            <Routes>
              {routes.filter((i) => i.key && i.page).map((i) => (
                <Route key={i.key} path={`/${i.key}`} element={i.page} />)
              )}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </article>
        </Content>
      </CustomLayout>
    </CustomLayout>
  )
}

export default Dashboard